import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { catchError, from, map, of, switchMap, tap } from "rxjs";
import { UsageOverviewDialogService } from "src/app/pages/billing/billing-status-widget/usage-overview-dialog.service";
import { SessionService } from "src/app/services/session.service";
import { AppInitialDataService } from "src/app/shared/services/app-initial-data.service";

export const loadInitialDataGuard: CanActivateFn = () => {
  const appInitialDataService = inject(AppInitialDataService);
  const sessionService = inject(SessionService);
  const usageOverviewDialog = inject(UsageOverviewDialogService);

  // Angular runs all canActivate guards for a route concurrently, not in
  // array order, so AuthGuard resolving `false` does not stop this guard
  // from firing. Check the session here too, and skip the bootstrap calls
  // when it's missing — AuthGuard already owns the redirect/dialog/signOut
  // for that case.
  return from(sessionService.isUserLoggedIn()).pipe(
    switchMap((isSignedIn) => {
      if (!isSignedIn) {
        return of(false);
      }

      return appInitialDataService.ensureInitialDataLoaded().pipe(
        tap(() => usageOverviewDialog.restorePersistedStateIfNeeded()),
        map(() => true),
        catchError(() => {
          sessionService.signOutUser();
          return of(false);
        }),
      );
    }),
  );
};
